import { Navigate, useParams } from 'react-router-dom';

import { useGetMedidaProducto } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveMedidasProductoPage } from '../../shared/saveMedidasProducto';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';

export interface UpdateMedidasProductoPageInterface {}

const UpdateMedidasProductoPage: React.FC<UpdateMedidasProductoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_unidadmedida);

  const { id } = useParams();
  const { data, isLoading } = useGetMedidaProducto(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_unidad_medida) return <Navigate to="/inventario/medidas-productos" />;

  return <SaveMedidasProductoPage titlePage="Editar medidas de producto" editMedidaProducto={data.data} />;
};

export default UpdateMedidasProductoPage;
